import { render, staticRenderFns } from "./PlaceCarrierBooking.vue?vue&type=template&id=61d7d4da&scoped=true&"
import script from "./PlaceCarrierBooking.vue?vue&type=script&lang=js&"
export * from "./PlaceCarrierBooking.vue?vue&type=script&lang=js&"
import style0 from "./PlaceCarrierBooking.vue?vue&type=style&index=0&id=61d7d4da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d7d4da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d7d4da')) {
      api.createRecord('61d7d4da', component.options)
    } else {
      api.reload('61d7d4da', component.options)
    }
    module.hot.accept("./PlaceCarrierBooking.vue?vue&type=template&id=61d7d4da&scoped=true&", function () {
      api.rerender('61d7d4da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/CustomActions/PlaceCarrierBooking/PlaceCarrierBooking.vue"
export default component.exports